const initState = {
    response: [],
    responseError: false

  };
  
  export default initState;
  